/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {BreadCrumbs} from '../../../components/BreadCrumbs/breadCrumbrs'
import {Button} from '../../../components/Button/Button'
import {Input} from '../../../components/Input/Input'
import {Loading} from '../../../components/Loading/Loading'
import {NewDatatable} from '../../../components/NewDataTable/NewDataTable'
import {DELETE, GET} from '../../../services/api'
import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'

type ReviewHotelCategoryItem = {
  id: number
  pluginspaceId: number
  title: string
  order: number
}

type ReviewHotelCategoryFilters = {
  title?: string
  order?: string
}

const initialFilters: ReviewHotelCategoryFilters = {
  title: '',
  order: '',
}

const ReviewsHotelCategoryIndex: FC = () => {
  const navigate = useNavigate()
  const [loading, setLoading] = useState(false)
  const [categories, setCategories] = useState<ReviewHotelCategoryItem[]>([])
  const [filters, setFilters] = useState<ReviewHotelCategoryFilters>(initialFilters)

  const formatData = (data: ReviewHotelCategoryItem[]) => {
    return data.map((item) => ({
      ...item,
      titleLabel: item.title || '-',
      orderLabel: item.order ?? 0,
    }))
  }

  const getReviewHotelCategories = async (searchFilters?: ReviewHotelCategoryFilters) => {
    try {
      const filtersToUse = searchFilters || filters
      const payload: Record<string, any> = {}

      if (filtersToUse.title) payload.title = filtersToUse.title
      if (filtersToUse.order) payload.order = filtersToUse.order

      const queryParams = new URLSearchParams(
        Object.entries(payload).reduce<Record<string, string>>((acc, [key, value]) => {
          acc[key] = String(value)
          return acc
        }, {})
      )

      const res = await GET(
        `/review-hotel-category${queryParams.toString() ? `?${queryParams}` : ''}`
      )
      const list = Array.isArray(res?.data) ? res.data : Array.isArray(res?.dados) ? res.dados : []

      setCategories(list)
    } catch (error) {
      console.log(error)
      setCategories([])
      Swal.fire({
        icon: 'error',
        title: 'Erro ao carregar',
        text: 'Não foi possível carregar as categorias.',
      })
    }
  }

  const handleFilterChange = (field: keyof ReviewHotelCategoryFilters, value: string) => {
    setFilters((prev) => ({
      ...prev,
      [field]: value,
    }))
  }

  const handleSearch = async () => {
    setLoading(true)
    try {
      await getReviewHotelCategories(filters)
    } finally {
      setLoading(false)
    }
  }

  const handleClearFilters = async () => {
    setLoading(true)
    try {
      setFilters(initialFilters)
      await getReviewHotelCategories(initialFilters)
    } finally {
      setLoading(false)
    }
  }

  const handleDelete = async (id: number) => {
    const confirmResult = await Swal.fire({
      icon: 'warning',
      title: 'Excluir categoria?',
      text: 'Esta ação não pode ser desfeita e removerá o vínculo dos formulários desta categoria.',
      showCancelButton: true,
      confirmButtonText: 'Excluir',
      cancelButtonText: 'Cancelar',
    })

    if (!confirmResult.isConfirmed) return

    try {
      setLoading(true)
      const res = await DELETE(`/review-hotel-category/${id}`)

      if (res?.success) {
        Swal.fire({
          icon: 'success',
          title: 'Excluída com sucesso',
          text: 'A categoria foi removida.',
        })
        await getReviewHotelCategories()
      } else {
        throw new Error(res?.message || 'Erro ao excluir a categoria')
      }
    } catch (error: any) {
      console.log(error)
      Swal.fire({
        icon: 'error',
        title: 'Erro ao excluir',
        text: error?.message || 'Não foi possível excluir a categoria.',
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      try {
        await getReviewHotelCategories()
      } catch (error) {
        console.error('Erro ao carregar dados:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <div className='row g-5 gx-xxl-12'>
          <div className='card card-xxl-stretch mb-5 mb-xl-12'>
            <div className='card-header py-5'>
              <h3 className='card-title align-items-start flex-column'>
                <span className='card-label fw-bolder fs-3 mb-1'>Categorias</span>
                <BreadCrumbs />
                <span className='text-muted mt-1 fw-bold fs-7'>
                  Gerencie as categorias dos formulários de opinião.
                </span>
              </h3>
              <div className='card-toolbar'>
                <Button
                  text='Nova Categoria'
                  color='primary'
                  iconColor='#FFF'
                  icon='fas fa-plus'
                  size='small'
                  horizontalPadding={6}
                  btnAttr={{type: 'button'}}
                  click={() => navigate('/hospitality/feed-back/category/criar')}
                  btnClass='mb-5 fw-bolder'
                />
              </div>
            </div>

            {/* <div className='card-body border-bottom'>
              <div className='row g-3'>
                <div className='col-md-3'>
                  <Input
                    label='Título'
                    inputAttr={{type: 'default'}}
                    value={filters.title || ''}
                    change={(value: string) => handleFilterChange('title', value)}
                    placeholder='Filtrar por título'
                  />
                </div>
                <div className='col-md-2'>
                  <Input
                    label='Ordem'
                    inputAttr={{type: 'number'}}
                    value={filters.order || ''}
                    change={(value: string) => handleFilterChange('order', value)}
                    placeholder='Nº'
                  />
                </div>

                <div className='col-12 d-flex justify-content-end gap-2'>
                  <Button text='Limpar' color='danger' size='small' click={handleClearFilters} />
                  <Button text='Filtrar' color='primary' size='small' click={handleSearch} />
                </div>
              </div>
            </div> */}

            <div className='card-body'>
              <NewDatatable
                data={formatData(categories)}
                headers={[
                  {key: 'Título', value: 'titleLabel', type: 'default'},
                  {key: 'Ordem', value: 'orderLabel', type: 'default'},
                  {key: 'Ações', value: 'acoes', type: ''},
                ]}
                options={[
                  {
                    icon: 'fas fa-pen',
                    action: (item) => navigate(`/hospitality/feed-back/category/edit/${item.id}`),
                    title: 'Editar categoria',
                  },
                  {
                    icon: 'fas fa-trash',
                    action: (item) => handleDelete(item.id),
                    title: 'Excluir categoria',
                  },
                ]}
                color='primary'
                search
              />
            </div>
          </div>
        </div>
      )}
    </>
  )
}

const ReviewsHotelCategory: FC = () => {
  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Dashboard', path: 'dashboard', isActive: false},
          {title: 'Hospitality', path: 'hospitality', isActive: false},
          {
            title: 'Categorias',
            path: 'hospitality/feed-back/category',
            isActive: true,
          },
        ]}
      >
        Categorias de Opinião
      </PageTitle>
      <ReviewsHotelCategoryIndex />
    </>
  )
}

export {ReviewsHotelCategory}
